if (typeof NewsletterPopup !== 'function') {
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.delaySeconds = Number(this.dataset.delay) || 5;
      this.cookieName = this.dataset.cookieName || 'newsletter-popup-dismissed';
      this.isEnabled = this.dataset.enabled === 'true';
      this.isDesignMode = Boolean(window.Shopify && Shopify.designMode);
      this.bodyClass = 'modal-opened';
      this._showTimeout = null;
    }

    connectedCallback() {
      if (!this.isEnabled && !this.isDesignMode) {
        return;
      }

      this._bindEvents();

      if (this.querySelector('[data-js-form-success]')) {
        this._setDismissCookie();
        return;
      }

      if (this._hasDismissCookie() && !this.isDesignMode) {
        return;
      }

      if (this.isDesignMode) {
        return;
      }

      this._showTimeout = window.setTimeout(() => {
        this.show();
      }, this.delaySeconds * 1000);
    }

    disconnectedCallback() {
      if (this._showTimeout) {
        window.clearTimeout(this._showTimeout);
      }
      document.removeEventListener('keydown', this._onKeydown);
    }

    show() {
      this.style.display = 'flex';
      window.setTimeout(() => {
        this.classList.add('active');
        document.body.classList.add(this.bodyClass);
      }, 10);
    }

    hide() {
      this.classList.remove('active');
      document.body.classList.remove(this.bodyClass);
      if (!this.isDesignMode) {
        this._setDismissCookie();
      }
      window.setTimeout(() => {
        this.style.display = 'none';
      }, 320);
    }

    _bindEvents() {
      this.querySelectorAll('[data-js-close]').forEach((elm) => {
        elm.addEventListener('click', () => this.hide());
      });

      this._onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) {
          this.hide();
        }
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    _hasDismissCookie() {
      return document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .some((cookie) => cookie.indexOf(this.cookieName + '=true') === 0);
    }

    _setDismissCookie() {
      const maxAge = 60 * 60 * 24 * 30;
      document.cookie =
        this.cookieName +
        '=true; path=/; max-age=' +
        maxAge +
        '; SameSite=None; Secure';
    }
  }

  if (typeof customElements.get('newsletter-popup') === 'undefined') {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.classList.contains('mount-newsletter-popup')) {
      const popup = event.target.querySelector('newsletter-popup');
      if (popup) {
        popup.show();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.classList.contains('mount-newsletter-popup')) {
      const popup = event.target.querySelector('newsletter-popup');
      if (popup) {
        popup.hide();
      }
    }
  });
}
